import React from  'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import logo from '../assets/img/logo.png';

const  HomeNav = () => {
  const secondaryColor = "#2D9CDB"
  return (
    <>
       {[false].map((expand) => (
         <Navbar key={expand} expand={expand} style={{ backgroundColor: '#992068' }}>
           <Container fluid>
             <Navbar.Brand>
             <img
              src={logo}
              width="252"
              height="63"
              className="d-inline-block align-top"
              alt="E-learning"
            />
             </Navbar.Brand>

             <Navbar.Toggle data-bs-theme="dark"  style={{ width: 90, background: secondaryColor  }} aria-controls={`offcanvasNavbar-expand-${expand}`} ></Navbar.Toggle>
             <Navbar.Offcanvas
               id={`offcanvasNavbar-expand-${expand}`}
               aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
               placement="end"
               data-bs-theme="dark"
               style={{ background: '#992068', color: 'white' }}
             >
               <Offcanvas.Header closeButton>
                 <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Menu
                 </Offcanvas.Title>
               </Offcanvas.Header>
               <Offcanvas.Body style={{ background: 'hsl(217, 28%, 15%)' }}>
                 <Nav className="justify-content-end flex-grow-1 pe-3">
                 <Nav.Link><Link className="text-light" to="/">Home</Link></Nav.Link>
                 <Nav.Link><Link className="text-light" to="/dashboard">Dashboard</Link></Nav.Link>
                 <Nav.Link><Link className="text-light" to="/plans">Plans</Link></Nav.Link>
                 <Nav.Link><Link className="text-light" to="/login">Log In</Link></Nav.Link>
                 <Nav.Link><Link className="text-light" to="/create-account">Create Account</Link></Nav.Link>
                 <Nav.Link><Link className="text-light" to="/contact">Contact us</Link></Nav.Link>
                 <Nav.Link target="_blank" href="https://blog.codefussion.tech">Blog</Nav.Link>
                 <Nav.Link><Link className="text-light" to="/">Privacy Policy</Link></Nav.Link>
                 <Nav.Link><Link className="text-light" to="/">Terms</Link></Nav.Link>
                 <Nav.Link target="_blank" href="https://api.whatsapp.com/send?phone=+2348084914979&text=Hello"><i style={{ backgroundColor: '#25d366', fontSize: 20, borderRadius:50 }} className="fab fa-whatsapp my-float"></i> Chat on WhatsApp</Nav.Link>

                   {/*<NavDropdown
                     title="Dropdown"
                     id={`offcanvasNavbarDropdown-expand-${expand}`}
                   >
                     <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                     <NavDropdown.Item href="#action4">
                       Another action
                     </NavDropdown.Item>
                     <NavDropdown.Divider />
                     <NavDropdown.Item href="#action5">
                       Something else here
                     </NavDropdown.Item>
                   </NavDropdown> */}
                 </Nav>
               </Offcanvas.Body>
             </Navbar.Offcanvas>
           </Container>
         </Navbar>
       ))}
     </>
  );
}

export default HomeNav;
